import { useState, useEffect } from 'react';

/**
 * Custom hook to detect mobile/tablet devices
 * Returns true if screen width is less than 1024px
 * Uses viewport width, not user agent sniffing
 */
const useMobile = () => {
    const [isMobile, setIsMobile] = useState(() => {
        // Initial check based on viewport width
        return window.innerWidth < 1024;
    });

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return isMobile;
};

export default useMobile;

